import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const GreenCheckmarkWithCircleGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('#4DBA28', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M51.641 25.8533V28C51.6381 33.0317 50.0088 37.9276 46.9961 41.9576C43.9833 45.9876 39.7486 48.9358 34.9234 50.3624C30.0983 51.7891 24.9412 51.6178 20.2214 49.874C15.5015 48.1303 11.4718 44.9076 8.73318 40.6865C5.99456 36.4654 4.69379 31.4722 5.02485 26.4514C5.35592 21.4307 7.30109 16.6514 10.5703 12.8265C13.8394 9.00159 18.2574 6.3359 23.1654 5.22702C28.0733 4.11813 33.2082 4.62546 37.8043 6.67334"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.6409 9.33334L28.3076 32.69L21.3076 25.69"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const GreenCheckmarkWithCircleSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <GreenCheckmarkWithCircleGroup {...props} />
    </svg>
  );
};
